export const environment = {
  production: true,
  apiBaseUrl: 'https://registroapi.crmstack.com.br',
  tipoSaas: 3
};
export default environment;
